(function() {
    'use strict';
    Odigeo.UIElements.enhanceSpinner = function($input, newoptions) {
        var options;
        var handler;
        var i;
        var info;
        var toggle;
        var toggleEnabled;
        var config;
        var setDefault;
        var setValue;
        var setValueDelta;
        var _tapHandler;
        var _tapHandlerDelta;
        var _refreshRange;
        var _isOpen;
        var _isEnabled;
        var $wrapper;
        var $display;
        var $select;
        var $switcher;

        if ($input.attr('data-skip-enhance') === 'true') {
            return;
        }
        $input.attr({'data-skip-enhance': true});

        // Init object with default options
        options = {
            enabled: true,
            step: Number($input.attr('step')) || 1,
            max: Number($input.attr('max')) || 9,
            min: Number($input.attr('min')) || 0,
            minRange: undefined,
            maxRange: undefined,
            button: 3,
            value: 0,
            currVal: 0,
        };
        options.minRange = options.min;
        options.maxRange = options.max;
        // Use initializing options
        options = Odigeo._.extend(options, $input.data(), newoptions);
        if (!Odigeo._.isUndefined($input.val())) {
            options.defaultValue = parseInt($input.val(), 10);
        }

        // Start widget construction
        $input.hide();

        $wrapper = $('<div>', {'class': 'od-ui-spinner-' + options.role + '-container spinner'});
        $display = $('<div>', {'class': 'od-ui-spinner-' + options.role + '-display spinner_display'});

        if (!options.enabled) {
            $wrapper.addClass('disabled');
        }
        if (Odigeo._.has(options, 'tabindex')) {
            $wrapper.attr('tabindex', options.tabindex);
        }

        $input.replaceWith($wrapper);
        if (options.role === 'switcher') {
            $wrapper
                .append($input)
                .append($('<div>', {'class': 'od-ui-spinner-switcher-field'})
                    .append($('<div>', {'class': 'od-ui-spinner-switcher-inputWithDesc'})
                        .append($display)
                        .append($input.data('description') ?
                            $('<div>', {'class': 'od-ui-spinner-switcher-desc', 'text': $input.data('description')}) :
                            $(''))
                    )
                    .append($('<div>', {'class': 'od-ui-spinner-switcher-buttonContainer'})
                        .append($('<span>', {'class': 'ficon', 'text': $input.data('button')}))
                    )
                );
            // Construct switcher
            $select = $('<select data-role="switcher">');

            for (i = parseInt(options.min, 10); i <= parseInt(options.max, 10); i += parseInt(options.step, 10)) {
                $('<option>', {
                    'value': i,
                    'text': i,
                }).appendTo($select);
            }
            $wrapper.append(
                $('<div>', {'class': 'od-ui-spinner-switcher-switcherContainer switcher_container'})
                    .append($select)
            );

            $switcher = Odigeo.UIElements.enhanceSwitcher($select);

            if (!Odigeo._.isUndefined(options.info)) {
                info = options.info;
                for (i = 0; i < info.length; i++) {
                    $wrapper.find('.switcher_container .switcher')
                        .append($('<div>', {'class': 'od-ui-spinner-switcher-info', 'text': info[i]})
                        );
                }
            }

            // Change value on the li elements
            $select.trigger('change', options.defaultValue);

            // Bind the switcher
            $select.on('change', Odigeo._.bind(function() {
                setValue(null, $select[0].value);
                toggle(false);
            }, this));
        } else if (options.role === 'aside') {
            var left;
            var middle;
            var right;
            var dec = $('<div>', {'class': 'od-aside-button dec', 'text': '-', 'tabindex': '-1'});
            var inc = $('<div>', {'class': 'od-aside-button inc', 'text': '+', 'tabindex': '-1'});

            if ($input.data('display') === 'middle') {
                left = dec;
                middle = $display;
                right = inc;
            } else {
                left = $display.addClass('display-left');
                middle = dec;
                right = inc;
            }

            $wrapper
                .append($input)
                .append($('<div>', {
                    'class': 'od-ui-spinner-aside-field odf-text-ellipsis',
                    'text': $input.data('aside'),
                })
                    .append($('<span>', {
                        'class': 'od-ui-spinner-aside-description',
                        'text': ' ' + $input.data('description'),
                    }))
                )
                .append($('<div>', {'class': 'od-ui-spinner-aside-buttons'})
                    .append($('<div>', {'class': 'od-ui-spinner-aside-buttonContainer'})
                        .append($(left))
                        .append($(middle))
                        .append($(right))
                    )
                );
        } else if (options.role === 'odf-aside') {
            var spinnerTemplate = Odigeo._.template($(options.template).html(), Odigeo.Utils.getTmplSettings());
            $wrapper.append($input)
                .append(spinnerTemplate({
                    aside: $input.data('aside'),
                    info: $input.data('info'),
                    description: $input.data('description'),
                }));
            $display = $wrapper.find('.spinner_display');
        } else {
            $wrapper
                .append($input)
                .append($('<div>', {'class': 'od-ui-spinner-incrementer-field'})
                    .append($('<div>', {'class': 'od-ui-spinner-incrementer-buttonContainerout dec spinner_incrementer_dec'})
                        .append($('<div>', {'class': 'od-ui-spinner-incrementer-buttonContainer dec'})
                            .append($('<span>', {'class': 'od-incrementer-button-plus', 'text': '_'}))
                        )
                    )
                    .append($('<div>', {'class': 'od-ui-spinner-incrementer-inputWithDesc'})
                        .append($display)
                    )
                    .append($('<div>', {'class': 'od-ui-spinner-incrementer-buttonContainerout inc spinner_incrementer_inc'})
                        .append($('<div>', {'class': 'od-ui-spinner-incrementer-buttonContainer inc'})
                            .append($('<span>', {'class': 'od-incrementer-button-less', 'text': '+'}))
                        )
                    )
                );

            if (!Odigeo._.isUndefined(options.info)) {
                info = options.info;
                if (Odigeo._.isArray(info)) {
                    Odigeo._.each(info, function(msg) {
                        $wrapper.append($('<div>', {'class': 'od-ui-spinner-incrementer-info', 'text': msg}));
                    });
                } else if (Odigeo._.isString(info)) {
                    $wrapper.append($('<div>', {'class': 'od-ui-spinner-incrementer-info', 'text': info}));
                }
            }
        }

        // End of widget construction
        // Functions

        setValue = function(evt, params) {
            var value;
            var text;

            // Might be called without event, or as an object
            if (Odigeo._.isUndefined(params)) {
                params = options.defaultValue;
            }

            if (Odigeo._.isObject(params)) {
                value = parseInt(params.value, 10);
            } else {
                value = parseInt(params, 10);
            }

            // Don't set the value if it's out of range
            if (value < Math.max(options.min, options.minRange) ||
                value > Math.min(options.max, options.maxRange)) {
                return;
            }

            $input[0].value = value;
            if (options.role === 'switcher') {
                $switcher.setValue(evt, value, true);
            } else {
                if ((value === Math.min(options.max, options.maxRange))) {
                    $wrapper.find('.inc').addClass('disabled');
                } else {
                    $wrapper.find('.inc').removeClass('disabled');
                }
                if ((value === Math.max(options.min, options.minRange))) {
                    $wrapper.find('.dec').addClass('disabled');
                } else {
                    $wrapper.find('.dec').removeClass('disabled');
                }
                options.currVal = value;
            }

            if (!Odigeo._.includes(['aside', 'odf-aside'], options.role)) {
                if ($input.data('pluralforms')) {
                    text = Odigeo.Utils.pluralizeAll($input.data('pluralforms'), value);
                } else {
                    if (value === 0) {
                        text = $input.data('zero');
                    } else if (value === 1) {
                        text = $input.data('singular');
                    } else if (value >= 1) {
                        text = $input.data('plural');
                    }
                    text = Odigeo.Utils.processCmsPlaceholder(value, text);
                }
                $display.text(text);
            } else {
                $display.text(value);
            }

            if (!params.silent) {
                $input.trigger('change', value);
            }
        };

        setValueDelta = function(delta) {
            setValue.call(this, null, parseInt($input.val(), 10) + delta);
        };

        toggle = function(show) {
            $wrapper.toggleClass('active', show);
        };

        toggleEnabled = function(enable) {
            $wrapper.toggleClass('disabled', !enable);
        };

        setDefault = function() {
            setValue(null, options.defaultValue);
        };

        config = function(evt, params) {
            // Parse everything into a number
            Odigeo._.map(params, function(val) {
                var parsed = parseInt(val, 10);
                if (!Odigeo._.isNaN(parsed)) {
                    return parsed;
                }
                return val;
            });

            $.extend(true, options, params);

            if (!Odigeo._.isUndefined(params.minRange) || !Odigeo._.isUndefined(params.maxRange)) {
                _refreshRange.apply(this);
            }
        };

        _refreshRange = function() {
            var disabledRange;

            // Change value to fit within bounds
            if (options.minRange < options.value) {
                setValue(null, options.minRange);
            }
            if (options.value > options.maxRange) {
                setValue(null, options.maxRange);
            }

            // Calculate values to be disabled

            if (options.role === 'switcher') {
                disabledRange = Odigeo._.range(options.min, options.minRange)
                    .concat(Odigeo._.range(options.maxRange + 1, options.max + 1));

                $switcher.disableItems(null, disabledRange);
            } else {
                if ((options.currVal === Math.min(options.max, options.maxRange))) {
                    $wrapper.find('.inc').addClass('disabled');
                } else {
                    $wrapper.find('.inc').removeClass('disabled');
                }
                if ((options.currVal === Math.max(options.min, options.minRange))) {
                    $wrapper.find('.dec').addClass('disabled');
                } else {
                    $wrapper.find('.dec').removeClass('disabled');
                }
            }
        };

        _isOpen = function() {
            return $wrapper.hasClass('active');
        };

        _isEnabled = function() {
            return !$wrapper.hasClass('disabled');
        };

        _tapHandler = function(evt) {
            if (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }

            if (_isEnabled()) {
                $input.triggerHandler(_isOpen() ? 'blur' : 'focus');
            }
        };

        _tapHandlerDelta = function(delta, evt) {
            if (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }

            if (_isEnabled()) {
                $input.trigger('focus');
                setValueDelta.call(this, delta);
            }
        };

        setValue(null, options.defaultValue);

        // Semi-public functions
        handler = {
            setValue: function(evt, value) {
                Odigeo._.bind(setValue, this, evt, value)();
                $input.closest('.more_options').removeClass('open');
            },
        };

        // UIElement bindings
        $input
            .on('open focus', Odigeo._.bind(toggle, this, true))
            .on('close blur', Odigeo._.bind(toggle, this, false))
            .on('enable', Odigeo._.bind(toggleEnabled, this, true))
            .on('disable', Odigeo._.bind(toggleEnabled, this, false))
            .on('setValue', Odigeo._.bind(setValue, this))
            .on('setDefault', Odigeo._.bind(setDefault, this))
            .on('config', Odigeo._.bind(config, this));

        // DOM bindings
        if (options.role === 'switcher') {
            $wrapper.on(Odigeo.Events.tap, Odigeo._.bind(_tapHandler, this));
        } else {
            $wrapper
                .on(Odigeo.Events.tap, '.inc', Odigeo._.bind(_tapHandlerDelta, this, 1))
                .on(Odigeo.Events.tap, '.dec', Odigeo._.bind(_tapHandlerDelta, this, -1));
        }

        return handler;
    };
}());
